import React from 'react'
import { Box, Typography, Autocomplete, TextField, FormHelperText } from '@mui/material'
import ValidationErrorText from '../common/ValidationErrorText'

const FormSelectAutocomplete = ({ label, value, options, onChange, readOnly = false,fieldError,placeholder }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography fontSize="14px" fontWeight="500" mb={0.5}>
        {label}
      </Typography>
      <Autocomplete
        fullWidth
        options={options}
        value={value}
        onChange={(_, newValue) => {
          if (!readOnly) onChange(newValue)
        }}
        slotProps={{
          paper: {
            sx: {
              '& .MuiAutocomplete-listbox': {
                fontSize: '13px',
              },
              '& .MuiAutocomplete-option': {
                fontSize: '13px',
                paddingY: '6px',
              },
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder ?? label ?? "Select Year"}
            sx={{
              '& .MuiInputBase-root': {
                height: 38,
                paddingRight: 1,
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 12px',
                fontSize: '13px',
              },
            }}
            disabled={readOnly}
          />
        )}
        disabled={readOnly}
      />
      <ValidationErrorText error={fieldError}/>
    </Box>
  )
}

export default FormSelectAutocomplete
